const searchOptions = [
  'Express - $500',
  'Express - $600',
  'Standard - $850',
  'Standard - $1,000',
  'Standard - $1,500',
  'Premium - $2,000',
  'Premium - $2,500',
  'Premium - $3,000',
  'Premium - $4,000',
  'Premium - $5,000',
  'Premium - $6,000',
  'Premium - $7,000',
  'Premium - $8,000',
  'Premium - $9,000',
  'Premium - $10,000',
]

const amountToQuantityMap = {
  500: 454,
  600: 545,
  850: 772,
  1000: 909,
  1500: 1363,
  2000: 1818,
  2500: 2272,
  3000: 2727,
  4000: 3636,
  5000: 4545,
  6000: 5454,
  7000: 6363,
  8000: 7272,
  9000: 8181,
  10000: 9090,
}

// BUSREQ-14042: NZ Leads Lift rate card - quantity equals the dollar amount
// 1:1 (no GST-style division like the AU map above).
const nzAmountToQuantityMap = {
  500: 500,
  600: 600,
  850: 850,
  1000: 1000,
  1500: 1500,
  2000: 2000,
  2500: 2500,
  3000: 3000,
  4000: 4000,
  5000: 5000,
  6000: 6000,
  7000: 7000,
  8000: 8000,
  9000: 9000,
  10000: 10000,
}

const getAmountToQuantityMap = country =>
  country === 'NZ' ? nzAmountToQuantityMap : amountToQuantityMap

// Reverse-maps a Recurly accounting quantity back to its canonical dollar
// tier (closest match). Mirrors LeadsLiftPanel.js's tierForQuantity for the
// 5.0 flow. Country-aware so AU (~amount/1.1) and NZ (1:1) both work.
// Used by the 4.0 lead-lift-view-v4 component to convert the raw Recurly
// quantity from subscription/uuid back to the user-facing dollar amount.
function tierForQuantity(quantity, country) {
  if (!quantity) return null
  const map = getAmountToQuantityMap(country)
  const tiers = Object.keys(map).map(Number)
  if (!tiers.length) return null
  return tiers.reduce((closest, tier) =>
    Math.abs(map[tier] - quantity) < Math.abs(map[closest] - quantity)
      ? tier
      : closest,
  )
}

export {
  searchOptions,
  amountToQuantityMap,
  nzAmountToQuantityMap,
  getAmountToQuantityMap,
  tierForQuantity,
}
